var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "popupMsg" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                "line-height": "40px",
                "font-weight": "bold",
                "text-align": "left",
                border: "1px solid #ddd",
                "padding-left": "14px",
                background: "#f4f5fa"
              }
            },
            [_vm._v("儿童信息")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "first_ul",
              staticStyle: { "list-style": "none", padding: "0 15px" }
            },
            [
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("身份证信息：" + _vm._s(_vm.row.idCard))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("姓名：" + _vm._s(_vm.ResultByMecList.childName))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("性别：" + _vm._s(_vm.ResultByMecList.sex))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("出生日期：" + _vm._s(_vm.ResultByMecList.birthday))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v(
                    "体检年龄：" +
                      _vm._s(_vm._f("converAge")(_vm.ResultByMecList.age))
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("联系人：" + _vm._s(_vm.ResultByMecList.contactPerson))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("手机号码：" + _vm._s(_vm.ResultByMecList.telphone))]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                "line-height": "40px",
                "font-weight": "bold",
                "text-align": "left",
                border: "1px solid #ddd",
                "padding-left": "14px",
                background: "#f4f5fa"
              }
            },
            [_vm._v("体检信息")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "first_ul",
              staticStyle: { "list-style": "none", padding: "0 15px" }
            },
            [
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("体检类型：" + _vm._s(_vm.row.mecTypeName))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("幼儿园：" + _vm._s(_vm.ResultByMecList.gardenName))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("体检日期：" + _vm._s(_vm.ResultByMecList.checkDate))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("体检单位：" + _vm._s(_vm.ResultByMecList.hospital))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("主检医师：" + _vm._s(_vm.ResultByMecList.doctor))]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                "line-height": "40px",
                "font-weight": "bold",
                "text-align": "left",
                border: "1px solid #ddd",
                "padding-left": "14px",
                background: "#f4f5fa"
              }
            },
            [_vm._v("一般检查")]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "first_ul",
              staticStyle: { "list-style": "none", padding: "0 15px" }
            },
            [
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v("身高：" + _vm._s(_vm.row.heightValue)),
                  _c("span", [_vm._v("cm")])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("评价结果：" + _vm._s(_vm.row.heightComment))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v("体重：" + _vm._s(_vm.row.weightValue)),
                  _c("span", [_vm._v("kg")])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("评价结果：" + _vm._s(_vm.row.weightComment))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v(
                    "体重指数(%)：" + _vm._s(_vm.ResultByMecList.weightPercent)
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v(
                    "肥胖指数(%)：" + _vm._s(_vm.ResultByMecList.fatPercent)
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [_vm._v("BMI：" + _vm._s(_vm.ResultByMecList.bmiValue))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticStyle: {
                    float: "left",
                    margin: "0px 25px 15px 0px",
                    height: "30px",
                    "line-height": "30px",
                    "min-width": "220px",
                    width: "360px"
                  }
                },
                [
                  _vm._v(
                    "综合评价：" + _vm._s(_vm.ResultByMecList.overallComment)
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.staffMecItemList, function(vl) {
                return [
                  vl.categoryId == 1 && vl.itemId != 1002 && vl.itemId != 1003
                    ? _c(
                        "li",
                        {
                          staticStyle: {
                            float: "left",
                            margin: "0px 25px 15px 0px",
                            height: "30px",
                            "line-height": "30px",
                            "min-width": "220px",
                            width: "360px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(vl.itemName) + "：\n                    "
                          ),
                          _c("span", [_vm._v(_vm._s(vl.itemResult) + " ")])
                        ]
                      )
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.CategoryList, function(item) {
            return _c(
              "div",
              { key: item.id },
              [
                item.id != 1
                  ? [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "40px",
                            "line-height": "40px",
                            "font-weight": "bold",
                            "text-align": "left",
                            border: "1px solid #ddd",
                            "padding-left": "14px",
                            background: "#f4f5fa"
                          }
                        },
                        [_vm._v(_vm._s(item.categoryName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "first_ul",
                          staticStyle: {
                            "list-style": "none",
                            padding: "0 15px"
                          }
                        },
                        [
                          _vm._l(_vm.staffMecItemList, function(vl) {
                            return [
                              item.id == vl.categoryId
                                ? _c(
                                    "li",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        margin: "0px 25px 15px 0px",
                                        height: "30px",
                                        "line-height": "30px",
                                        "min-width": "220px",
                                        width: "360px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(vl.itemName) +
                                          "：\n                            "
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(vl.itemResult) + " ")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } })
                    ]
                  : _vm._e()
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                "line-height": "40px",
                "font-weight": "bold",
                "text-align": "left",
                border: "1px solid #ddd",
                "padding-left": "14px",
                background: "#f4f5fa"
              }
            },
            [_vm._v("检查结果（医院评定）")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text_div",
              staticStyle: {
                overflow: "hidden",
                width: "100%",
                padding: "15px",
                "box-sizing": "border-box"
              }
            },
            [
              _c(
                "textarea",
                {
                  staticStyle: {
                    float: "left",
                    height: "100px",
                    width: "100%"
                  },
                  attrs: { maxlength: "100", disabled: "true" }
                },
                [_vm._v(_vm._s(_vm.ResultByMecList.checkResult))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                "line-height": "40px",
                "font-weight": "bold",
                "text-align": "left",
                border: "1px solid #ddd",
                "padding-left": "14px",
                background: "#f4f5fa"
              }
            },
            [_vm._v("医生意见")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text_div",
              staticStyle: {
                overflow: "hidden",
                width: "100%",
                padding: "15px",
                "box-sizing": "border-box"
              }
            },
            [
              _c(
                "textarea",
                {
                  staticStyle: {
                    float: "left",
                    height: "100px",
                    width: "100%"
                  },
                  attrs: { maxlength: "100", disabled: "true" }
                },
                [_vm._v(_vm._s(_vm.ResultByMecList.doctorSuggestion))]
              )
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-primary",
              staticStyle: { margin: "10px 0" },
              on: {
                click: function($event) {
                  _vm.printMecInfo()
                }
              }
            },
            [_vm._v("打印")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.dialogVisible,
            width: "60%",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("幼儿园端体检详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6790cf28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6790cf28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/physical/physical_org_det.vue
// module id = null
// module chunks = 